import { render } from "./CreatePage.vue?vue&type=template&id=47c621ca&scoped=true"
import script from "./CreatePage.vue?vue&type=script&lang=js"
export * from "./CreatePage.vue?vue&type=script&lang=js"

import "./CreatePage.vue?vue&type=style&index=0&id=47c621ca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c621ca"]])

export default __exports__